export default {
  init() {
    // JavaScript to be fired on all pages
    window.$ = window.jQuery;

    /**
     * Applies a fading effect on the navbar
     *
     * @return {undefined}
     */
    function applyNavbarEffect() {
      let effectHeight = 500;
      let scrollTop = $(window).scrollTop();
      let effects = [
        { min: 0, max: 1 },
        { min: 0, max: 0.5 },
      ];

      effects.forEach((v) => {
        v.range = v.max - v.min;
      });

      let regExp = new RegExp(
        /rgba?\((\d{1,3}), (\d{1,3}), (\d{1,3})(?:, ((?:0|0\.\d+)))?\)/i
      );

      let navbar = $('.navbar-box');
      let backgroundColor = navbar.css('background-color');
      let match = backgroundColor.match(regExp);

      effectHeight;
      scrollTop;
      match;

      // navbar.css({ backgroundColor: `rgba(${match[1]}, ${match[2]}, ${match[3]}, ${effects[0].min + Math.max(0, 1 - (scrollTop / effectHeight)) * effects[0].range})` });
    }

    $(function() {
      applyNavbarEffect();

      $(window).scroll(function() {
        applyNavbarEffect();
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
